import { Plus } from "lucide-react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { faqs } from "@/data/site";

export const FaqList = ({ items = faqs }) => (
  <AccordionPrimitive.Root type="single" collapsible className="border-t hairline" data-testid="faq-accordion">
    {items.map((f, i) => (
      <AccordionPrimitive.Item key={f.q} value={`q-${i}`} className="border-b hairline">
        <AccordionPrimitive.Header>
          <AccordionPrimitive.Trigger data-testid={`faq-trigger-${i}`} className="group flex w-full items-center justify-between gap-6 py-5 md:py-6 text-left text-[18px] md:text-[20px] font-medium tracking-[-0.01em] hover:text-[color:var(--violet)] transition-colors duration-300">
            {f.q}
            <span className="shrink-0 flex h-10 w-10 items-center justify-center rounded-lg border hairline transition-transform duration-400 ease-[var(--ease)] group-data-[state=open]:rotate-45 group-data-[state=open]:bg-[color:var(--plum)] group-data-[state=open]:text-white group-data-[state=open]:border-[color:var(--plum)]">
              <Plus className="h-4 w-4" strokeWidth={1.75} />
            </span>
          </AccordionPrimitive.Trigger>
        </AccordionPrimitive.Header>
        <AccordionPrimitive.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
          <p className="pb-6 text-[color:var(--ink-2)] leading-relaxed max-w-2xl" data-testid={`faq-content-${i}`}>{f.a}</p>
        </AccordionPrimitive.Content>
      </AccordionPrimitive.Item>
    ))}
  </AccordionPrimitive.Root>
);
